import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import VideoCallPageGrid from "../../common/VideoCall/VideoCallGridLayout";

const VideoCall = ({userId, mode}) => {
  console.log("mode at masterpageprofile: ", {mode})

  return (
    <div style={{width: "100%", height: "100%"}}>
      <VideoCallPageGrid userId={userId} mode={mode}/>
    </div>
  );
};

export default VideoCall;
